import script from "./InputSelectAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputSelectAtom.vue?vue&type=script&setup=true&lang=ts"

import "./InputSelectAtom.vue?vue&type=style&index=0&id=8c244954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c244954"]])

export default __exports__